import { deleteLocalidad, getLocalidadesPanel } from "../../services/LocalidadesServices";
import { LocalidadesContext } from "./LocalidadesContext"

export const LocalidadesState = ({ children }) => {

    const getLocalidadesPanelData = async (searchTerm,searchIDFilter ,searchIDSecondFilter ,numpag, filas) => {
        let res = await getLocalidadesPanel(searchTerm,searchIDFilter ,searchIDSecondFilter , numpag, filas)
        return res
    }

    const deleteLocalidadData = async (body,searchFilter,searchTerm, numpag, filas) => {
        const res = await deleteLocalidad(body)
        if (res) getLocalidadesPanelData(searchFilter,searchTerm, numpag, filas)
        return res
    }

    return <LocalidadesContext.Provider value={{
        deleteLocalidadData,
        getLocalidadesPanelData,
    }} >
        {children}
    </LocalidadesContext.Provider>
}
